class RegistrationCompletedNotify {
  static getEmailData = (dst, user) => {
    const from = `Gobierno de El Salvador <info@goes.gob.sv>`;

    const to = dst;
    const subject = `¡Felicitaciones! Tu proceso de registro ha sido completado`;
    const body = templeteData(user);

    return {
      from,
      to,
      subject,
      body
    };
  };
}

export default RegistrationCompletedNotify;

const templeteData = (user) => {
  return `
        <h2 style="text-align: center;">
            Tu proceso de registro ha sido completado - Portal de Proyectos Gobierno de El Salvador
        </h2>
        <br />
        <p>Estimado(a) ${user?.displayName}</p>
        <br />
        <p>
            Queremos informarte que tu solicitud de registro ha sido completado con éxito, ya estas autorizado para el inscribir proyecto a través del portal de proyectos del Gobierno de El Salvador en favor a la institución a la que representas.
        </p>
        <p>
            Ingresa al portal y enviar tu primer proyecto <a href="${'https://portal.modernizacion.gob.sv'}">aquí</a>.
        </p>
        <br />
        <br />
        <p>Saludos,</p>
        <br />
        <p>Portal de Proyectos Gobierno de El Salvador en Convenio con Google LLC</p>`;
};
